<ng-container *transloco="let t">
    <mat-toolbar class="tool-bar">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center"
            style="background-color: #ea7600;min-height:50px;height:50px;">
            <h1 fxFlex style="color: white; font-size: 16px; font-weight: bold;">Document Summary</h1>
            <button style="color: white;" mat-icon-button class="close-button">
                <mat-icon (click)="close()">close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="mat-typography">
        <table class="info-table">
            <tr>
                <td class="label">Document Name</td>
                <td class="colon">:</td>
                <td class="value">{{ data.fileName }}</td>
            </tr>
            <tr>
                <td class="label">State Name</td>
                <td class="colon">:</td>
                <td class="value">{{ data.stateName === 'Start' && data.actionType === 'N' ? 'Need More Info':
                    data.stateName }}</td>
            </tr>
            <tr>
                <td class="label">Uploaded Date</td>
                <td class="colon">:</td>
                <td class="value">{{ data.uploadedDate }}</td>
            </tr>
            <tr>
                <td class="label">Uploaded By</td>
                <td class="colon">:</td>
                <td class="value">{{ data.uploadedBy }}</td>
            </tr>
            <tr *ngIf="data.versionNumber">
                <td class="label">Version</td>
                <td class="colon">:</td>
                <td class="value">{{ data.versionNumber }}</td>
            </tr>
            <tr *ngIf="data.status">
                <td class="label">Status</td>
                <td class="colon">:</td>
                <td class="value">{{ data.status }}</td>
            </tr>
        </table>
    </mat-dialog-content>
</ng-container>